module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"Account":"ანგარიში","ItemCode":"კოდი","Amount":"რაოდენობა","Unit":"ერთეული","Price":"ფასი","ExpireDate":"ვადა","MohProductOtherDetailsGeo":"აღწერა"},"en":{"Account":"Account","ItemCode":"Code","Amount":"Amount","Unit":"Unit","Price":"Price","ExpireDate":"Expire Date","MohProductOtherDetailsGeo":"Description"}}')
  delete Component.options._Ctor
}
